import { render, staticRenderFns } from "./SelectedItems.vue?vue&type=template&id=1fe9815a&scoped=true&"
import script from "./SelectedItems.vue?vue&type=script&lang=js&"
export * from "./SelectedItems.vue?vue&type=script&lang=js&"
import style0 from "./SelectedItems.vue?vue&type=style&index=0&id=1fe9815a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9815a",
  null
  
)

export default component.exports